import React from "react";
import DepthIcon from "./Icons/Depth";
import HeightIcon from "./Icons/Height";
import WeightIcon from "./Icons/Weight";
import WidthIcon from "./Icons/Width";
import styled, { css } from "styled-components";
import TickBlackIcon from "./Icons/TickBlack";

const ProductSpecStyles = styled.div`
  ${({ ...props }) => css`
    h3 {
      margin-bottom: 32px;
    }

    li {
      display: flex;
      align-items: center;
      border-top: ${(props.$small ? "none" : `solid 1px ${props.$grey ? '#bfbfbe' : '#e9ece9'};`)};
      padding-top: ${(props.$small ? "0" : "16px")};
      & + li {
        margin-top: ${(props.$small ? "2px" : "16px")};
      }

      p {
        flex-grow: 1;
        display: flex;
        justify-content: space-between;
        text-align: right;

        strong {
          text-align: left;
        }
      }

      &:last-child {
        border-bottom: ${(props) => props.$small ? "none" : `solid 1px ${props.$grey ? '#bfbfbe' : '#e9ece9'};`};
        padding-bottom: ${(props.$small ? "0" : "16px")};
      }
    }

    @media (min-width: ${props.theme.breakpoints.xl}) {
      padding-right: ${(props.$small ? "0" : "32px")};
    }
  `}
`;

const ProductSpecIconStyles = styled.div`
  ${({ ...props }) => css`
    flex-basis: 24px;
    width: 24px;
    height: 24px;
    margin-right: ${(props.$small ? "10px" : "16px")};
    display: flex;
    justify-content: center;
    align-items: center;
    @media (min-width: ${props.theme.breakpoints.md}) {
    }
  `}
`;

export const ProductSpecification = ({ specification, small = false, grey = false }) => {
  return specification.height ||
    specification.heightWithFence ||
    specification.depth ||
    specification.width ||
    specification.weight ||
    specification.filledWeight ? (
    <ProductSpecStyles $small={small} $grey={grey}>
      {!small &&
      (specification.height ||
        specification.heightWithFence ||
        specification.depth ||
        specification.width ||
        specification.weight ||
        specification.filledWeight) ? (
        <h3>Key features</h3>
      ) : (
        ``
      )}
      <ul>
        {specification.height ? (
          <li>
            <ProductSpecIconStyles $small={small}>
              <HeightIcon />
            </ProductSpecIconStyles>
            <p>
              <strong>Height </strong> {specification.height}
            </p>
          </li>
        ) : (
          ""
        )}
        {specification.heightWithFence ? (
          <li>
            <ProductSpecIconStyles $small={small}>
              <HeightIcon />
            </ProductSpecIconStyles>
            <p>
              <strong>Height with Fencing </strong> {specification.heightWithFence}
            </p>
          </li>
        ) : (
          ""
        )}
        {specification.depth ? (
          <li>
            <ProductSpecIconStyles $small={small}>
              <DepthIcon />
            </ProductSpecIconStyles>
            <p>
              <strong>Depth </strong> {specification.depth}
            </p>
          </li>
        ) : (
          ""
        )}
        {specification.width ? (
          <li>
            <ProductSpecIconStyles $small={small}>
              <WidthIcon />
            </ProductSpecIconStyles>
            <p>
              <strong>Width </strong> {specification.width}
            </p>
          </li>
        ) : (
          ""
        )}
        {specification.weight ? (
          <li>
            <ProductSpecIconStyles $small={small}>
              <WeightIcon />
            </ProductSpecIconStyles>
            <p>
              <strong>Weight</strong> {specification.weight}
            </p>
          </li>
        ) : (
          ""
        )}
        {specification.filledWeight ? (
          <li>
            <ProductSpecIconStyles $small={small}>
              <WeightIcon />
            </ProductSpecIconStyles>
            <p>
              <strong>Filled Weight</strong> {specification.filledWeight}
            </p>
          </li>
        ) : (
          ""
        )}
        {specification.customAttributes &&
        specification.customAttributes.length > 0
          ? specification.customAttributes.map((attribute, index) => {
              return (
                <li key={index}>
                  <ProductSpecIconStyles $small={small}>
                    <TickBlackIcon />
                  </ProductSpecIconStyles>
                  <p>
                    <strong>{attribute.attribute}</strong>{" "}
                    {attribute?.value}
                  </p>
                </li>
              );
            })
          : ""}
      </ul>
    </ProductSpecStyles>
  ) : (
    <></>
  );
};
